import { useFormikContext } from "formik";
import { useCurrentWorkspaceMembers } from "@api/workspaceMember.api";
import { DefaultAssigneeField } from "../DefaultAssigneeField";
import type { TemplateTaskDetailsValues } from "./templateTaskDetails.schema";
import { useTaskTemplateMode } from "./useTaskTemplateMode";

const ClientDefaultAssignee = () => {
    const formik = useFormikContext<TemplateTaskDetailsValues>();
    const { data: members } = useCurrentWorkspaceMembers();

    return (
        <DefaultAssigneeField
            members={members}
            value={formik.values.assigneeId}
            onChange={(value) => {
                void formik.setFieldValue("assigneeId", value);
            }}
        />
    );
};

export const TemplateAssigneeSlot = () => {
    const mode = useTaskTemplateMode();

    if (mode === "orgTemplate") {
        return null;
    }

    return <ClientDefaultAssignee />;
};
